<script setup lang="ts">

import { DROP_ZONE_STATUS, DropZoneItem, DropZoneList, RowInfo } from '@shared/ui/other'
import { ModalDefault } from '@shared/ui/modals'
import { AppTextarea, NativeSelect } from '@shared/ui/fields'
import { AppText } from '@shared/ui/typography'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import DisciplineTutorSelect from '../DisciplineTutorSelect.vue'
import { useModalDisciplineFilePack } from '../../model/modal-discipline-file-pack.hook'

defineOptions({
  name: 'ModalDisciplineFilePack',
})

const {
  refIsOpen,
  refIsLoading,
  refPack,
  refForm,
  refTutorId,
  refTitle,
  refLastUpdate,
  refCategoryOptions,
  refTaskOptions,
  refPackTaskText,
  refIsChanged,
  canManageFiles,
  setCategory,
  setTask,
  setComment,
  closeModal,
  savePack,
} = useModalDisciplineFilePack()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsLoading"
    :title="refTitle"
    @click:overlay="closeModal"
  >
    <div
      v-if="refPack && refForm"
      class="modal-discipline-files"
    >
      <AppText
        name="body2"
        color="slate-500"
      >
        Last update: {{ refLastUpdate }}
      </AppText>
      <NativeSelect
        id="select-file-type"
        name="select_file_type"
        label="Select type of files"
        :options="refCategoryOptions"
        :value="refForm.category"
        :disabled="!canManageFiles"
        @change="setCategory"
      />
      <DisciplineTutorSelect
        v-model="refTutorId"
        label="Select tutor"
        placeholder="-- Not selected --"
        :disabled="!canManageFiles"
        clearable
      />
      <RowInfo
        v-if="refPackTaskText"
        title="Task:"
        :value="refPackTaskText ?? undefined"
      />
      <NativeSelect
        v-else-if="refTaskOptions.length"
        id="select-task-tutor"
        name="select_task_tutor"
        label="Task"
        placeholder-enabled
        placeholder="Select task"
        :options="refTaskOptions"
        :value="refForm.task_id"
        :disabled="!canManageFiles"
        @change="setTask"
      />
      <AppTextarea
        name="files_comment"
        label="Comment"
        placeholder="Type here"
        :value="refForm.comment ?? ''"
        :disabled="!canManageFiles"
        @input="setComment"
      />
      <DropZoneList
        v-if="refPack.files.length"
        title="Uploaded files"
      >
        <DropZoneItem
          v-for="file in refPack.files"
          :key="file.id"
          :name="file.filename"
          :size="file.filesize"
          :status="DROP_ZONE_STATUS.Success"
          :view-link="file.view_link"
          :download-link="file.download_link"
          :removable="false"
        />
      </DropZoneList>
    </div>
    <template #controls>
      <div class="modal-discipline-files__controls">
        <BtnPrimary
          v-if="canManageFiles"
          text="Edit"
          color="emerald"
          :disabled="refIsLoading || !refIsChanged"
          @click="savePack"
        />
        <BtnSecondary
          text="Cancel"
          color="black"
          :disabled="refIsLoading"
          @click="closeModal"
        />
      </div>
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineFiles.scss" />
